module.exports = __webpack_public_path__ + "static/media/synth_09.af5866b0.mp3";